const v = (value) =>
  value === null || value === undefined || value === "" ? "-" : value;

export const TradeSupport = (trade = {}) => {
  const rawItems = [
    ["Turnover Incentive Amount", v(trade.TurnoverIncentiveAmount)],
    ["Turnover", v(trade.Turnover)],
    ["Turnover Realization Frequency", v(trade.TurnoverRealizationFrequency)],
    ["Turnover Realization Method", v(trade.TurnoverRealizationMethod)],

    ["Merchandising Amount (/Person)", v(trade.MerchandisingAmountRsPerPerson)],
    ["Merchandising No./Store", v(trade.MerchandisingNoOfPersonPerStore)],
    ["Merchandising On Turnover", v(trade.MerchandisingOnTurnover)],
    ["Merchandising Frequency", v(trade.MerchandisingRealizationFrequency)],
    ["Merchandising Method", v(trade.MerchandisingRealizationMethod)],

    [
      "Damage Stock Returnable By Gate Pass",
      trade.DamageStockReturnableByGatePass ? "Yes" : "",
    ],
    ["Damage Stock Replacement", trade.DamageStockReplacement ? "Yes" : ""],
    [
      "Vendor Will Take Back Damage",
      trade.DamageVendorWillTakeBackStocks ? "Yes" : "",
    ],
    [
      "Damage Allowance (No Return)",
      v(trade.DamageNoStockReturnOrReplacementButAllowance),
    ],
    ["Damage Frequency", v(trade.DamageRealizationFrequency)],
    ["Damage Method", v(trade.DamageRealizationMethod)],

    ["Barcode Amount/Qty", v(trade.BarcodeAmountPerQuantity)],
    ["Barcode On Turnover", v(trade.BarcodeOnTurnover)],
    ["Barcode Frequency", v(trade.BarcodeRealizationFrequency)],
    ["Barcode Method", v(trade.BarcodeRealizationMethod)],

    ["New Product Amount", v(trade.NewProductAmount)],
    ["New Product On Turnover", v(trade.NewProductOnTurnover)],
    ["New Product Frequency", v(trade.NewProductRealizationFrequency)],
    ["New Product Method", v(trade.NewProductRealizationMethod)],

    ["Store Opening Amount/SKU", v(trade.StoreOpeningAmountSKU)],
    ["Store Opening Frequency", v(trade.StoreOpeningRealizationFrequency)],
    ["Store Opening Method", v(trade.StoreOpeningRealizationMethod)],

    ["Store Anniversary Amount/Store", v(trade.StoreAnniversaryAmountPerStore)],
    [
      "Store Anniversary Frequency",
      v(trade.StoreAnniversaryRealizationFrequency),
    ],
    ["Store Anniversary Method", v(trade.StoreAnniversaryRealizationMethod)],

    ["Listing Fee", v(trade.ListingFee)],

    ["Shrink Sharing", trade.ShrinkSharing === "true" ? "Yes" : ""],
    ["Shrink Sharing On Turnover", v(trade.ShrinkSharingTurnover)],

    ["Any Other OP1 Desc", v(trade.AnyOtherOP1Desc)],
    ["Any Other OP1 Amount", v(trade.AnyOtherOP1ConsiderationAmount)],
    ["Any Other OP1 Frequency", v(trade.AnyOtherOP1RealizationFrequency)],
    ["Any Other OP1 Method", v(trade.AnyOtherOP1RealizationMethod)],

    ["Any Other OP2 Desc", v(trade.AnyOtherOP2Desc)],
    ["Any Other OP2 Amount", v(trade.AnyOtherOP2ConsiderationAmount)],
    ["Any Other OP2 Frequency", v(trade.AnyOtherOP2RealizationFrequency)],
    ["Any Other OP2 Method", v(trade.AnyOtherOP2RealizationMethod)],

    ["Any Other OP3 Desc", v(trade.AnyOtherOP3Desc)],
    ["Any Other OP3 Amount", v(trade.AnyOtherOP3ConsiderationAmount)],
    ["Any Other OP3 Frequency", v(trade.AnyOtherOP3RealizationFrequency)],
    ["Any Other OP3 Method", v(trade.AnyOtherOP3RealizationMethod)],

    ["TOT Agreement", v(trade.TOTAgreement)],

    ["Turnover 2023–2024", v(trade.LastThreeYearTurnover?.[0]?.TurnoverAmount)],
    ["Turnover 2024–2025", v(trade.LastThreeYearTurnover?.[1]?.TurnoverAmount)],
    ["Turnover 2025–2026", v(trade.LastThreeYearTurnover?.[2]?.TurnoverAmount)],
  ];

  const rows = [];
  for (let i = 0; i < rawItems.length; i += 2) {
    rows.push(rawItems.slice(i, i + 2));
  }

  return `
<h5>Trade Support</h5>

<style>
  .trade-table {
    width: 100%;
    border-collapse: collapse;
    page-break-inside: auto;
  }
  .trade-table tr {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .trade-table td {
    border: 1px solid #000;
    padding: 6px;
    vertical-align: top;
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .trade-table td div {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .lbl {
    font-weight: 600;
    white-space: nowrap;
  }
</style>

<table class="trade-table">
  ${
    rows.length === 0
      ? `<tr><td colspan="4" style="text-align:center;">No Trade Support Data Available</td></tr>`
      : rows
          .map(
            (row) => `
            <tr>
              ${row
                .map(
                  ([label, value]) => `
                  <td class="lbl"><div>${label}</div></td>
                  <td><div>${value}</div></td>
                `
                )
                .join("")}
            </tr>
          `
          )
          .join("")
  }
</table>
`;
};